exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fade-enter-active[data-v-7806c143],.fade-leave-active[data-v-7806c143]{transition:opacity .5s}.fade-enter[data-v-7806c143],.fade-leave-to[data-v-7806c143]{opacity:0}", ""]);

// exports
